import styled from 'styled-components'

export const BreastContainer = styled.div`
  position: relative;
  padding: 1.5rem;
  height: 100%;
  width: 100%;

  display: flex;
  gap: 1.5rem;

  border-radius: 8px;
  background-color: ${({ theme }) => theme.zds.colors.neutral1000};
`

export const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  height: 100%;
  width: 100%;
  background-color: ${({ theme }) => theme.zds.colors.neutral1000};
  border-radius: 8px;
`

export const ErrorTitle = styled.h3`
  margin-top: 2rem;
  color: ${props => props.theme.colors.color545e6c};
  font-family: 'Inter';
  font-size: 24px;
  font-style: normal;
  font-weight: 600;
  line-height: 28.8px;
`

export const ErrorDescription = styled.p`
  margin-top: 1rem;
  color: ${props => props.theme.colors.color545e6c};
  text-align: center;
  font-family: 'Inter';
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
  white-space: pre-wrap;
`

export const LegendCriteriaSection = styled.section`
  position: relative;
  width: 100%;
  max-width: 300px;
  padding: 1rem;
  background: ${props => props.theme.colors.colorf3f5f9};
  border: 1px solid ${props => props.theme.colors.color122d52};
  border-radius: ${({ theme }) => theme.zds.border.radius100};
`

export const Text = styled.p`
  font-family: 'Inter';
  font-style: normal;
  font-weight: 400;
  font-size: 10px;
  line-height: 15px;
  color: ${props => props.theme.colors.color545e6c};
`

export const Anchor = styled.a`
  color: ${props => props.theme.colors.color378ff7};
  font-family: 'Inter';
  font-size: 10px;
  font-style: normal;
  font-weight: 400;
  line-height: 15px;
  text-decoration-line: underline;
`
